import React, { Component } from 'react'
import { FormGroup, Input, FormText } from 'reactstrap';
export class ImageUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: '',
            imagePreviewUrl: this.props.fileData || '',
            msgCheckFile: ''
        };
        this._handleImageChange = this._handleImageChange.bind(this);
    }
    _handleImageChange(e) {
        e.preventDefault();
        let idSetting = this.props.idSetting
        let file = e.target.files[0];
        let imgSize = file.size
        let maxSize = this.props.maxSize || 512000
        if (imgSize > maxSize) {
            this.setState({
                msgCheckFile: "Dung lượng file vượt quá mức cho phép",
            });
            this.props.onChangeFile(null, idSetting)
            return false;
        } else {
            let reader = new FileReader();
            reader.onloadend = () => {
                this.setState({
                    file: file,
                    imagePreviewUrl: reader.result
                });
                this.props.onChangeFile(reader.result, idSetting)
            }
            reader.readAsDataURL(file)
        }
    }
    render() {
        let { imagePreviewUrl, msgCheckFile } = this.state;
        let $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = (<img className="pull-left" style={{ height: "55px" }} src={imagePreviewUrl} />);
        }
        return (
            <div className="row">
                <div className="col-sm-8">
                    <form className="md-form">
                        <FormGroup>
                            <Input type="file" name="file" onChange={this._handleImageChange} accept="image/*" />
                            {
                                msgCheckFile == '' ?
                                    <FormText color="warning" className="text-danger text-left">
                                        Logo công ty dạng .png không được vượt quá 500kb, tỷ lệ kích thước dài:rộng = 3:1 (ví dụ : 120 x 40)
                                    </FormText>
                                    :
                                    <FormText color="warning" className="text-danger text-left">
                                        {msgCheckFile}
                                    </FormText>
                            }

                        </FormGroup>
                    </form>
                </div>
                <div className="col-sm-4">
                    {$imagePreview}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/controls/_ImageUpload.js